<template>

  <v-footer
    light
    padless
  >
    <v-card
      width="100%"
      flat
      tile
      class="w-100 lighten-1 text-center"
    >
      
      <v-card-text class="pa-3">
        <div class="linkWrapper" no-gutters>
          <!-- Menu left -->
          <template v-if="mustShowMenu">
            <span v-for="(item,index) in menu" :key="'btnFooterText-'+index"  :justify="(isXsDevice)?'center':'left'">
              <router-link v-if="item.link" class="caption no-underline link" :to="item.link">{{item.title}}</router-link>
            </span>
          </template>
          <!-- Copyrights right -->
          <!--
          <v-col cols="12" sm="4" class="caption ">
            © {{ new Date().getFullYear() }} espoto GmbH
          </v-col>
          -->
        </div>
        <div class="linkWrapper" style="margin-top: 0.5em;">
          <span style="color:grey" class="caption link">Version {{version}}</span>
        </div>
      </v-card-text>
      
    </v-card>
  </v-footer>
</template>

<script>
import CONFIG from '@/constants/config.js';
import {settingsMixin} from '@/utils/settings-mixin'
import {layoutMixin} from '@/utils/layout-mixin'

export default {
  mixins: [settingsMixin,layoutMixin],
  data () {
    return {
      icons: [
      ],
      version:CONFIG.APP_VERSION 
    }
  },
  computed: {
    menu() {
      return [
        { title: this.$t('imprint'), link:'/impressum' },
        /*{ title: 'AGB',link:'/agb' },*/
        { title: this.$t('privacyPolicy'),link:'/datenschutz' }
      ]
    },
    mustShowMenu(){
        return true
      // const storedPrivacyVersion = localStorage.getItem('privacyVersion');
      // const currentPrivacyVersion = CONFIG.VUE_APP_PRIVACY_VERSION;
      // return storedPrivacyVersion == currentPrivacyVersion;
    }
  },
  methods:{

  }
}
</script>

<style scoped>
.link{
  margin-right: 20px;
  color:black;
  font-family: 'Poppins';
}
.linkWrapper{
  max-width:900px;
  margin:auto;
  text-align:center;
}
</style>
